import { type TFunction } from "i18next";
import { CertificationKind } from "@relay/createLicensesButton_CreateLicensesMutation.graphql";

export const getCertificationDataOptions = (
	t: TFunction,
): Array<{
	label: string;
	value: CertificationKind;
}> => [
	{ label: t("license.withCertification"), value: "WithCertification" },
	{ label: t("license.courseContentOnly"), value: "CourseContentOnly" },
	{ label: t("license.certificationUpgrade"), value: "CertificationUpgrade" },
];
